import { ReactNode, useState } from 'react';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';

interface AdminLayoutProps {
  children: ReactNode;
  fullWidth?: boolean;
}

/**
 * Main admin layout with fixed sidebar and sticky header
 */
export default function AdminLayout({ children, fullWidth }: AdminLayoutProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-pine-paper">
      {/* Fixed Sidebar */}
      <AdminSidebar 
        mobileMenuOpen={mobileMenuOpen} 
        onCloseMobileMenu={() => setMobileMenuOpen(false)}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed(!collapsed)}
      />

      {/* Mobile Overlay */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-30 lg:hidden"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      {/* Main Content Area */}
      <div className={`transition-all duration-300 flex flex-col min-h-screen ${
        collapsed ? 'lg:ml-16' : 'lg:ml-64'
      }`}>
        {/* Sticky Header */}
        <AdminHeader
          onMobileMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)}
          mobileMenuOpen={mobileMenuOpen}
        />

        {/* Main Content */}
        <main className="flex-1 p-4 sm:p-6">
          <div className={fullWidth ? '' : 'max-w-7xl mx-auto'}>
            {children}
          </div>
        </main>

        {/* Footer */}
        <footer className="border-t border-pine-line py-3 px-6">
          <p className="text-pine-ink-soft text-sm text-center">
            © {new Date().getFullYear()} PlayMoments
          </p>
        </footer>
      </div>
    </div>
  );
}
